export default __webpack_public_path__ + "static/media/tourly-book-1440.6aba9d2a.png";